import * as React from 'react';
import {useGetNextCardUrlQuery} from "../../../types.d";
import {Redirect, RouteComponentProps, RouterProps} from "react-router";
import {graphql} from "../../../configs/graphql.client";

export const NextUrl = (props: RouteComponentProps<{ courseId: string, role: string }>) => {
    const loadUrl = useGetNextCardUrlQuery({
        fetchPolicy: 'network-only',
        variables: {
            courseId: Number(props.match.params.courseId),
            role: props.match.params.role
        }
    });

    if (loadUrl.data) {
        return <Redirect to={loadUrl.data.nextCardUrl} />
    }

    if (loadUrl.loading) {
        return null;
    }

    return null;
};
